module.exports = __webpack_public_path__ + "img/instagram-story.189c9702.png";